/* js/navSimple.js */

jQuery(document).ready(function ($) {

    $(document).ready(function () {

        var $navSimple = $('.navSimple');
        $navSimple.dropit();

        var liCount = $('.navSimple__item').length;

        $('.navSimple__item').css('width', liCount / 100 * 10 + '%');

        //console.log(liCount);

        $('.js_navTrigger ').click(function () {
            $('body').addClass('navIsOpen');
        });

        $('.js_navTrigger-close').click(function () {
            $('body').removeClass('navIsOpen');
        });


    });
});

